import { config } from '@/config';
import ApiLocal from '@/api/ApiLocal';
import Api from '@/api/ApiServer';

export default {
  getMe(token) {
    if (config.api.useLocalStore) return ApiLocal.getMe(token);
    return Api.getMe(token);
  },
  createTrip(trip, user) {
    if (config.api.useLocalStore) return ApiLocal.createTrip(trip, user);
    return Api.createTrip(trip, user);
  },
  updateTrip(tripId, trip) {
    if (config.api.useLocalStore) return ApiLocal.updateTrip(tripId, trip);
    return Api.updateTrip(tripId, trip);
  },
  deleteTrip(tripId) {
    if (config.api.useLocalStore) return ApiLocal.deleteTrip(tripId);
    return Api.deleteTrip(tripId);
  },
  getTrip(tripId) {
    if (config.api.useLocalStore) return ApiLocal.getTrip(tripId);
    return Api.getTrip(tripId);
  },
  getTrips(user) {
    if (config.api.useLocalStore) return ApiLocal.getTrips(user);
    return Api.getTrips(user);
  },
  updateTripTitle(tripId, title) {
    if (config.api.useLocalStore) return ApiLocal.updateTripTitle(tripId, title);
    return Api.updateTripTitle(tripId, title);
  },
  createUser(email, name) {
    if (config.api.useLocalStore) return ApiLocal.createUser(email, name);
    return Api.createUser(email, name);
  },
  updateUserName(userId, name) {
    if (config.api.useLocalStore) return ApiLocal.updateUserName(userId, name);
    return Api.updateUserName(userId, name);
  },
  updateUserInstitution(userId, institutionId) {
    if (config.api.useLocalStore) return ApiLocal.updateUserInstitution(userId, institutionId);
    return Api.updateUserInstitution(userId, institutionId);
  },
  getInstitutioner(kommunenr) {
    if (config.api.useLocalStore) return ApiLocal.getInstitutioner(kommunenr);
    return Api.getInstitutioner(kommunenr);
  },
};
